import { render, staticRenderFns } from "./appointment.vue?vue&type=template&id=4be53e8a&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/.15.7.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports